import { render, staticRenderFns } from "./DataGoals.vue?vue&type=template&id=05a5b6d7"
import script from "./DataGoals.vue?vue&type=script&lang=js"
export * from "./DataGoals.vue?vue&type=script&lang=js"
import style0 from "./DataGoals.vue?vue&type=style&index=0&id=05a5b6d7&prod&tyest=sass&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports